module.exports = __webpack_public_path__ + "static/media/31.77a23fa6.JPG";